import { createFileRoute } from '@tanstack/react-router';
import { loadShire, makeShireSubPageHead, type ShireLoaderData } from '../components/shared/shire-sub-route';
import { ShireSubPageShell } from '../components/shared/ShireSubPageShell';
import { ShireConnectivitySection } from '../components/shared/ShireConnectivitySection';

export const Route = createFileRoute('/shire/$name_/connectivity')({
  loader: ({ params }) => loadShire(params.name),
  head: (ctx) =>
    makeShireSubPageHead(
      (ctx as { loaderData?: ShireLoaderData } | undefined)?.loaderData,
      'Connectivity',
      'NBN by town, mobile coverage, known black spots and Sky Muster satellite for this shire.',
    ),
  component: ConnectivityPage,
});

function ConnectivityPage() {
  const { shire } = Route.useLoaderData() as ShireLoaderData;
  return (
    <ShireSubPageShell
      shire={shire}
      eyebrow="Connectivity"
      title="Internet & mobile coverage"
      lede={`NBN options, mobile coverage, known black spots and satellite alternatives in the Shire of ${shire.name}.`}
    >
      <ShireConnectivitySection shireId={shire.id} />
    </ShireSubPageShell>
  );
}
